import logo from './logo.svg';
import { useEffect, useState } from "react";
import './App.css';
// import "../src/assets/scss/style.scss"
import Hero from './Components/Hero';

import feather from 'react-feather';
import { AOS } from 'aos';
import Routing from './Components/Routing';



function App() {
  const mybutton = document.getElementById("scrollBtn");
  const [scrolll, setScrolll] = useState(0);

  window.onscroll = function () {
    scrollFunction();
 };





//  function backToTopInit() {
//     // declare variable
//     var scrollTop = ('.backto-top');
//     (window).scroll(function () {
//         var topPos = (this).scrollTop();
//         if (topPos > 100) {
//           (scrollTop).css('opacity', '1');

//         } else {
//             (scrollTop).css('opacity', '0');
//         }
//     });


//     (scrollTop).on('click', function () {
//       ('html, body').animate({
//           scrollTop: 0,
//           easingType: 'linear',
//       }, 500);
//       return false;
//   });
//   }

  function scrollFunction() {
    if (
      document.body.scrollTop > 20 ||
      document.documentElement.scrollTop > 20
    ) {
      setScrolll(1);
    } else {
      setScrolll(0);
    }
  }


    const backToTopInit = () => {
      window.scroll({
        // if user scrolls down - show scroll to top button
        top: 0,
        behavior: "smooth",
      });
    };


    return (
      <div>
        <div
          id="scrollBtn"
          onClick={() => {
            backToTopInit();
          }}
          style={{
            boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
            color: "#ff014f",
            position: "fixed",
            borderRadius: "50%",
            width: "50px",
            height: "50px",
            zIndex: "5555",
            bottom: "4vh",
            display: `${scrolll ? "flex" : "none"}`,
            right: "1.5vw",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          <i className="feather-arrow-up"></i>
        </div>


        <Routing />
       
      </div>
    );
  }

  export default App;
